<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('tf balance View');
  },
}
</script>

<style scoped>

</style>
